import Module from '../../utils/modules/Module';
import gsap from 'gsap';

export default class HeaderHubModule extends Module {
  constructor(options) {
    super(options);
    this.openNav = this.openNav.bind(this);
    this.closeNav = this.closeNav.bind(this);
    this.toggleNav = this.toggleNav.bind(this);
    this.reset = this.reset.bind(this);

    this.DOMEl = options.element;
    this.id = options.id;

    this.filterButton = this.DOMEl.querySelector('.filter-mobile');
    this.filterList = this.DOMEl.querySelector(".filter-collections");
    this.listElements = this.filterList.querySelectorAll("li");
    this.init();
  }

  init() {
    this.filterButton.addEventListener('click', this.toggleNav)
    window.addEventListener('resize', this.reset);
  }

  reset() {
    if (window.innerWidth >= 770 && this.filterList.style.display === 'none') {
      this.filterList.style.display = 'grid';
      gsap.fromTo(this.listElements, {opacity: 0}, {opacity: 1, delay: 0.3, duration: 0.3, stagger: 0})
    }
  }

  toggleNav() {
    if (!this.filterButton.classList.contains('active')) {
      this.openNav()
    } else {
      this.closeNav();
    }
  }

  openNav() {
    this.filterButton.classList.add('active');
    this.filterList.style.display = 'block';

    gsap.delayedCall(0.1, () => {
      this.filterList.classList.add('active');

      gsap.fromTo(this.listElements, {opacity: 0}, {opacity: 1, delay: 0.3, duration: 0.3, stagger: 0})
    })
  }

  closeNav() {
    gsap.fromTo(this.listElements, {opacity: 1}, {
      opacity: 0, duration: 0.3, stagger: 0, onComplete: () => {
        this.filterList.classList.remove('active');
        gsap.delayedCall(0.3, () => {
          this.filterButton.classList.remove('active');
          this.filterList.style.display = 'none';
        })
      }
    })
  }
}
